function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 14,
  cy: 14,
  r: 14,
  fill: "#0D5AE5"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.106 10.744L4.188 16H3.378L4.485 9.7H5.619L7.464 14.992L8.4 9.7H9.21L8.103 16H6.987L5.106 10.744ZM10.8043 9.7H14.5393L14.4133 10.438H11.5243L11.1913 12.355H13.6663L13.5403 13.075H11.0653L10.6783 15.262H13.5583L13.4323 16H9.69734L10.8043 9.7ZM14.9353 9.727L15.8173 9.637L16.3033 15.091L18.4993 10.357H19.5703L20.0743 15.091L22.4773 9.664L23.2333 10.015L20.4613 16H19.3993L18.8863 11.266L16.6813 16H15.6193L14.9353 9.727Z",
  fill: "white"
});

var SvgNewTag = function SvgNewTag(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNewTag, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/New_tag.6933168a.svg";
export { ForwardRef as ReactComponent };